import { Size } from './types.common'

export const SIZES_MAP_PX: Record<Size, number> = {
  L: 24,
  M: 20,
  S: 18,
}

export const ICON_GAP = 10
